export class Langue {
  public id: number;
  public codeLangue?: string;
  public description?: string;
  public parDefault?: boolean;
}
